import { produce } from 'immer';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import {
  LocalStorageActions,
  LocalStorageState,
  TypingBoxSettings,
  TypingBoxSettingsMap,
} from '@Root/src/store/useLocalStorageStore.types';

import { DEFAULT_LANGUAGE_ISO } from '@Components/helper/language';

import { UseTypingMode } from '@Store/useTypingStore.types';

import { JuicynessLevel, TypingTestFontSize } from '@Helpers/types/typing-test';

const typingBoxDefaultSettings = {
  fontFace: 'var(--font-roboto-slab)',
  fontSize: TypingTestFontSize.Medium,
  rows: 2,
  useHighContrast: false,
  useTimer: true,
  showStats: false,
  showAdvancedResult: false,
  showInvisibleChars: false,
  languageIso: DEFAULT_LANGUAGE_ISO,
  juicynessLevel: JuicynessLevel.Low,
};

const useLocalStorageStore = create<LocalStorageState & LocalStorageActions>()(
  persist(
    (set, get): LocalStorageState & LocalStorageActions => ({
      typingBoxSettings: {
        [UseTypingMode.TypingTest]: typingBoxDefaultSettings,
        [UseTypingMode.Competition]: typingBoxDefaultSettings,
        [UseTypingMode.Multiplayer]: typingBoxDefaultSettings,
        [UseTypingMode.CustomTypingTest]: typingBoxDefaultSettings,
        [UseTypingMode.TextPractice]: {
          ...typingBoxDefaultSettings,
          fontSize: TypingTestFontSize.Small,
          rows: 20,
        },
      },
      reset: () => console.log('todo reset'),
      setTypingBoxSettings: (typingBoxSettings: TypingBoxSettingsMap) =>
        set(
          produce((state) => {
            state.typingBoxSettings = typingBoxSettings;
          })
        ),
      updateTypingBoxSetting: (key: string, typingBoxSettings: TypingBoxSettings) =>
        set(
          produce((state) => ({
            typingBoxSettings: {
              ...state.typingBoxSettings,
              [key]: typingBoxSettings,
            },
          }))
        ),
    }),
    {
      name: 'settings',
    }
  )
);

export default useLocalStorageStore;
